/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import formatDate from '../../../../../helpers/formatDate'
import { IconWithContentCardContent } from '../Shared/IconWithContentCardContent'

const CheckoutSystemCardContent = ({data}) => {
    const [t] = useTranslation()

    return (
      <IconWithContentCardContent
        iconElement={(
          <>
              <Icon color="grey" name="plug"/>
              <Icon
                corner
                name={(data.state === undefined || data.state.status === 'OK') ? 'checkmark' : 'ban'}
                color={(data.state === undefined || data.state.status === 'OK') ? 'green' : 'red'}
              />
          </>
        )}
        contentElement={(
          <div>
              <p
                css={css`
                    font-weight: bold;
                    margin-bottom: .5rem;
                `}>
                  {t('checkout_system.checkout_system', {moduleName: data?.name})}
              </p>
              {data.state?.sentAt &&
                <p>
                    {t('checkout_system.state.lastSentAt')}<br/>
                    <b>{formatDate(data.state.sentAt)}</b>
                </p>
              }
          </div>
        )}
      />
    )
}

export { CheckoutSystemCardContent }
